import React, { createContext, useState, useContext, Children } from 'react';

export const EddContext = React.createContext({ value: false, id:''});



